import {Platform} from 'react-native';
import FastImage from 'react-native-fast-image';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
  align-items: center;
  justify-content: center;
`;
export const Header = styled.View`
  background-color: ${({theme}) => theme.colors.primary};
  height: ${RFPercentage(35)}px;
  width: 100%;
`;

//@ts-ignore
export const ImageBoarding = styled(FastImage)`
  width: ${RFValue(148)}px;
  height: ${RFValue(320)}px;
  margin-bottom: ${RFValue(12)}px;
  border-radius: ${RFValue(24)}px;
  border:4px solid ${({theme}) => theme.colors.black};
`;

export const Content = styled.View`
  flex: 1;
  margin-top: -${Platform.OS === 'ios' ? RFPercentage(25) : RFPercentage(35)}px;
  justify-content: center;
  padding: 0 24px;
  align-items: center;
  /* background-color: ${({theme}) => theme.colors.placeholder}; */
`;
export const Footer = styled.View`
  padding: 0 24px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
  width: 100%;
`;
export const ContainerText = styled.View`
  width: 100%;
  align-items: center;
  margin-top: ${RFValue(12)}px;
`;
export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  margin-bottom: ${RFValue(6)}px;

  text-align: center;
`;
export const Subtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  text-align: center;
`;

export const TextButton = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  align-items: center;
  align-content: center;
`;

export const LinkButton = styled.TouchableOpacity`
  border-style: solid;
  border-color: ${({theme}) => theme.colors.blue};
  border-bottom-width: 2px;
`;
export const LinkButtonText = styled.Text`
  color: ${({theme}) => theme.colors.blue};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
`;
export const LinkButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: ${RFValue(12)}px;
`;
export const DotContainer = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(12)}px;
  margin-right: -${RFValue(6)}px;
`;

export const Dot = styled.View`
  margin-right: ${RFValue(6)}px;
`;
export const DotIcon = styled(FontAwesome)`
  font-size: ${RFValue(8)}px;
`;